<template>
  <div>
      <div class="flex flex-col gap-4">
        <div class="vx-row">
          <div class="vx-col w-full">
              <b-form-group
                id="newsletter_title"
                :label="$t('newsletter.title')"
                label-for="newsletter_title">
                <b-form-input
                  id="newsletter_title"
                  name="newsletter_title"
                  v-model="model.title"
                  disabled/>
              </b-form-group>
          </div>
        </div>
        <!-- Legal Entity -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <b-form-group
              id="legal_entity_name"
              :label="$t('legal_entities_unit')"
              label-for="legal_entity_name">
                <b-form-input
                  id="legal_entity_name"
                  name="legal_entity_name"
                  :value="legalEntityName"
                  disabled>
                </b-form-input>
            </b-form-group>
          </div>
        </div>
        <!-- Group News -->
        <div class="vx-row">
          <div class="vx-col w-full sm:w-1/2">
              <b-form-group
                id="group_news_name"
                :label="$t('group_news.group')"
                label-for="group_news_name">
                <b-form-input
                  id="group_news_name"
                  name="group_news_name"
                  v-model="model.group_news_name"
                  disabled/>
              </b-form-group>
          </div>
          <div class="vx-col w-full sm:w-1/2">
            <b-form-group
                id="subgroup_news_name"
                :label="$t('subgroup_news.subgroup')"
                label-for="subgroup_news_name">
                <b-form-input
                  id="subgroup_news_name"
                  name="subgroup_news_name"
                  v-model="model.subgroup_news_name"
                  disabled/>
              </b-form-group>
          </div>
        </div>
        <!-- -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <b-form-group
                id="newsletter_link"
                :label="$t('newsletter.link')"
                label-for="newsletter_link">

                <span class="align-left w-full flex text-break cursor-pointer gap-2 p-1"
                  v-clipboard:copy="linkFull"
                  v-clipboard:success="() => {notifySuccess($vs, 'Cópia realizada com sucesso.')}"
                  v-clipboard:error="() => {notifyError($vs, 'Não foi possível realizar a cópia.')}"
                  v-tooltip.top="{content: 'Copiar link completo',delay: { show: 100, hide: 100 }}"
                  >
                  <feather-icon
                      icon="LinkIcon"
                      svgClasses="h-5 w-5 mb-1 stroke-current text-primary mr-1 align-midle"/>
                  {{linkFull}}
                </span>
              </b-form-group>
          </div>
        </div>
        <!-- -->
        <div class="vx-row">
          <div class="vx-col flex">
              <b-form-group
                :label="$t('newsletter.status')"
                label-for="status">
                <b-form-radio-group
                  id="status"
                  name="status"
                  v-model="model.status"
                  disabled>
                  <b-form-radio value="DR">{{$t('newsletter.status_.DR')}}</b-form-radio>
                  <b-form-radio value="RE">{{$t('newsletter.status_.RE')}}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
          </div>
          <div class="vx-col flex">
              <b-form-group
                :label="$t('newsletter.allows_comment')"
                label-for="allows_comment">
                <b-form-checkbox
                  id="allows_comment"
                  name="allows_comment"
                  v-model="model.allows_comment"
                  switch class="mr-n2"
                  disabled>
                </b-form-checkbox>
              </b-form-group>
          </div>
          <div class="vx-col flex">
            <b-form-group
              :label="$t('newsletter.allows_enjoy')"
              label-for="allows_enjoy">
              <b-form-checkbox
                id="allows_enjoy"
                name="allows_enjoy"
                v-model="model.allows_enjoy"
                switch class="mr-n2"
                disabled>
              </b-form-checkbox>
            </b-form-group>
          </div>
          <div class="vx-col flex">
            <b-form-group
              :label="$t('newsletter.allows_signature')"
              label-for="allows_signature">
              <b-form-checkbox
                id="allows_signature"
                name="allows_signature"
                v-model="model.allows_signature"
                switch class="mr-n2"
                disabled>
              </b-form-checkbox>
            </b-form-group>
          </div>

        </div>
        <div class="vx-row">
          <div class="vx-col flex w-full">
            <b-form-group
              :label="$t('newsletter.content')"
              label-for="content"
              class="w-full">
              <vs-divider></vs-divider>
              <complex-editor-view :editor_data.sync="model.content"/>
            </b-form-group>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="w-full flex items-center gap-3">
              <div class="flex items-center px-1 py-1.5 rounded" style="background-color: rgba(var(--vs-primary), 0.1)">
                <feather-icon
                  icon="ThumbsUpIcon"
                  class="h-4 w-4 text-primary mr-1"/>
                <span class="text-primary">{{countLike}}</span>
                <span class="text-primary ml-1 text-sm">{{$t('newsletter.like')}}</span>
              </div>
              <div class="flex items-center px-1 py-1.5 rounded" style="background-color: rgba(var(--vs-primary), 0.1)">
                <feather-icon
                  icon="EyeIcon"
                  class="h-4 w-4 text-primary mr-1"/>
                <span class="text-primary">{{countView}}</span>
                <span class="text-primary ml-1 text-sm">{{$t('newsletter.view')}}</span>
              </div>
              <div class="flex items-center px-1 py-1.5 rounded" style="background-color: rgba(var(--vs-primary), 0.1)">
                <feather-icon
                  icon="MessageCircleIcon"
                  class="h-4 w-4 text-primary mr-1"/>
                <span class="text-primary">{{countComments}}</span>
                <span class="text-primary ml-1 text-sm">{{$t('newsletter.comment_total')}}</span>
              </div>
              <!--
              <div class="flex items-center px-1 py-1.5 rounded" style="background-color: rgba(var(--vs-primary), 0.1)">
                <feather-icon
                  icon="MessageCircleIcon"
                  class="h-4 w-4 text-warning mr-1"/>
                <span class="text-primary">{{countCommentsWithoutModerator}}</span>
                <span class="text-primary ml-1 text-sm">{{$t('newsletter.comment_without_moderator')}}</span>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>

import { isAdmin } from '@/util/Util'
import {
  BRow,
  BCol,
  BCardText,
  BForm,
  BFormGroup,
  BFormRadioGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BFormCheckbox,
  BFormRadio,
  BButton,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupText,
  BIconClipboard,
  VBTooltip,
} from 'bootstrap-vue'

import ComplexEditor from '@/components/ComplexEditor.vue'
import ComplexEditorView from '@/components/ComplexEditorView.vue'
import NewsletterService from '@/services/api/NewsletterService'

export default {
   directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormRadioGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BFormCheckbox,
    BFormRadio,
    BCardText,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupText,
    BIconClipboard,
    ComplexEditor,
    ComplexEditorView,
  },
  props: {
    id: {
      default: null,
      type: Number
    }
  },

  data: () => ({
    service: null,
    model: {
      id: null,
      title : '',
      link: '',
      status: '',
      allows_comment: false,
      allows_enjoy: false,
      allows_signature: false,
      legal_entity: {
        name: '',
        is_headquarters: false,
      },
      content: '',
    },
  }),
  computed: {
    legalEntityName(){
      return _.get(this.model, 'legal_entity.name', '')
    },
    linkFull(){
      return `${this.protocolLocation()}/#/newsletters/pub/${_.kebabCase(this.model.link)}`
    },
    countLike(){
      return _.get(this.model,'data.like', 0)
    },
    countView(){
      return _.get(this.model,'data.view', 0)
    },
    countComments(){
      return _.get(this.model,'comments_count', 0)
    },
    countCommentsWithoutModerator(){
      return _.get(this.model,'comments_without_moderator_count', 0)
    },
  },
  beforeMount() {
    this.service = NewsletterService.build(this.$vs)
  },
  mounted() {
    if (this.id) {
      this.loadData(this.id)
    }
  },

  methods: {
    loadData(id) {
      this.$vs.loading()

      this.service.read(id).then(
        response => {
          this.model = response
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    goBack() {
      this.$router.push('/newsletters')
    },
    isAdmin() {
      return isAdmin()
    },
  }
}
</script>

<style>

</style>
